import React from "react";
import { Link, useLocation } from "react-router-dom";
import registrationSuccessIcon from "./img/registration-success-icon.svg";

const RegistrationSuccessModal = ({ translate }) => {
    const location = useLocation();
    return (
        <section className="ibank-registration-success header-sign-section-modal">
            <div className="header-sign-section-container">
                <div className="registration-container">
                    <img
                        src={registrationSuccessIcon}
                        className="registration-container-icon"
                        alt="registrationSuccessIcon"
                    />
                    <h2 className="registration-container-title registration-container-title--center">
                        {translate("registration completed successfully")}
                    </h2>
                    <p className="registration-container-description registration-container-description--center">
                        {window.location.href.includes("/juridical/asan") ? translate("Enter ASAN number and ID to log in to the system") : translate("Enter your PIN (FIN) code and password to log in")}
                    </p>
                    <div className="registration-container-footer">
                        <Link
                            to="/login/individual/mobile"
                            className="registration-container-footer-button registration-container-footer-button--center w-50 text-center"
                        >
                            {translate("login")}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RegistrationSuccessModal;
